module.exports = __webpack_public_path__ + "static/media/XRP.3668ef3b.svg";